import localeEn from '../../../../../../locales/en'
import localeAr from '../../../../../../locales/ar'

export default {
    name: 'notification-card-template',
    props: ['notificationData'],
    data() {
        return {
        }
    },

    methods: {
       // notification date
        notificationDate(date) {
            return new Date(date).toLocaleString('en-GB', { year: 'numeric', month: 'numeric', day: 'numeric' });
        },
        //notification time 
        notificationTime(date) {
            return new Date(date).toLocaleTimeString([], { timeStyle: 'short' }) + ",";
        },
        //notification msg 
        messageHTML(data) {
            return `${data}`;
        }
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },

}
